/**
 * PRODUCT_DEV-748: ビルド variant（Unizo / Minizo）の判定。
 *
 * Minizo は「Unizo からメモ・ToDo だけを切り出したデモ版」(PRODUCT_DEV-688)。
 * フロントだけを別エントリ（`main.minizo.tsx` / `router.minizo.tsx`）としてビルドし、
 * API・DynamoDB・Cognito は Unizo をそのまま流用する。
 *
 * **同じ基盤に乗せる理由**は「Minizo を気に入った人が Unizo へアップグレードする」導線で、
 * アップグレード時にデータ移行を発生させないため。TenantProducts に unizo を 1 行足すだけで
 * 同じ ID のまま Minizo で貯めたメモ・ToDo が Unizo 側でも見える状態になる。
 *
 * 判定には CI が既に渡している `VITE_PRODUCT_ID`（`.github/workflows/unizo.yaml`）を使う。
 * 新しい env を増やさないのは、Portal への往復（ログイン/ログアウト）で使う productId と
 * 必ず同じ値でなければならないため。2 つに分けると片方だけ直したときに認証が壊れる。
 *
 * 未設定のローカル開発では Unizo として扱う。
 */
export const MINIZO_PRODUCT_ID = "minizo";

/**
 * Minizo ビルドかどうか。
 *
 * `ENV.PRODUCT_ID` 経由ではなく `import.meta.env` を直接見るのは**意図的**。
 * Vite は `import.meta.env.VITE_*` をビルド時に文字列リテラルへ置換するため、
 * ここは `"minizo" === "minizo"` まで畳まれて定数 `true`/`false` になる。
 * その結果 `IS_MINIZO ? A : B` の未使用側が Rollup の DCE で消え、
 * そこからしか参照されない import（議事録一覧など）ごと dist から落ちる。
 * オブジェクトのプロパティ参照（`ENV.PRODUCT_ID`）にすると畳める保証が無い。
 *
 * 値そのものは `ENV.PRODUCT_ID` と同一。Portal への往復で使う productId と
 * ずれてはいけないので、参照元の env は 1 つ（`VITE_PRODUCT_ID`）に保つこと。
 */
export const IS_MINIZO = import.meta.env.VITE_PRODUCT_ID === MINIZO_PRODUCT_ID;

/**
 * localStorage のトークン保存名。
 * Minizo は別オリジンなので実際には衝突しないが、`clearToken` の引数と
 * `setTokenProvider` の storeName は必ず同じ値でなければならないため定数化する
 * （片方だけ "unizo" のままだとログアウトでトークンが消えず、再訪時に認証済み扱いになる）。
 */
export const TOKEN_STORE_NAME = IS_MINIZO ? "minizo" : "unizo";

/** 画面に出すサービス名。ロゴ・タイトル・文言で使う。 */
export const APP_NAME = IS_MINIZO ? "Minizo" : "Unizo";
